// extracted by mini-css-extract-plugin
export default {"title":"ContentTitle_title__TroWa","title_container":"ContentTitle_title_container__2lSNC","author":"ContentTitle_author__4Knm8","nobreak":"ContentTitle_nobreak__evZ04"};